import React from 'react';
import { Paper, Button, Title, Stack, Flex } from '@mantine/core';
import { inject, observer } from 'mobx-react';
import { useNavigate } from 'react-router-dom';
import { IconPlus } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import WrappedSavedMMECalculationsTable from '../Table/SavedMMECalculationsTable.tsx';

const MMECalculationsSection: React.FC = inject()(
    observer(() => {
        const { t } = useTranslation();
        const [mmeFocused, setMmeFocused] = React.useState(false);
        const navigate = useNavigate();

        return (
            <Paper h={'100%'} style={{ display: 'flex', flexDirection: 'column', backgroundColor: mmeFocused ? '#f8f9fa' : 'white' }} 
            onMouseEnter={() => setMmeFocused(true)}
                onMouseLeave={() => setMmeFocused(false)}>
                <Stack h={'100%'}>
                    <Flex justify={'space-between'} align="flex-start" gap="md">
                        
                        <Title order={4}>
                            {t('mme.calculator.title', 'MME Calculator')}
                        </Title>
                        <Button
                            variant="filled"
                            leftSection={<IconPlus size={14} />}
                            onClick={() => navigate('/hcpPatientDashboard/dosageModeling/mmeCalculator')}
                        >
                            {t('mme.calculator.addNew', 'Ajouter un nouveau calcul')}
                        </Button>
                        
                    </Flex>
                <WrappedSavedMMECalculationsTable />
                </Stack>
            </Paper>
        );
    }),
);

export default MMECalculationsSection;
